<div class="checkbox-container">
    <input type="checkbox" class="custom-checkbox" [formControl]="control" [id]="id" class="custom-checkbox"
        [class.submitted]="isSubmitted" />
</div>